import { handleActions } from "redux-actions";
import { setConverterConfigOpen } from "../actions/actions";

export default handleActions(
  {
    [setConverterConfigOpen]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
